import App from "@/app";
import { createGlobalApi } from "@/modules/irohana-components/utils/api";
import reportWebVitals from "@/reportWebVitals";
import { globalBaseURL, onError } from "@/utils/api";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import ReactDOM from "react-dom/client";

// irohana-components ships its own axios instance that its services (files, enums, ...) call.
// It must be initialized once before render, pointed at the same /global base URL and auth cookie the app uses.
createGlobalApi({
  apiHost: globalBaseURL,
  onError,
  getAuthToken: () => Cookies.get("admin-token"),
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 0.5, //  Capture 50% of the transactions

  autoSessionTracking: true, // Automatically track sessions

  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: "irohana@1.0.0",
});

root.render(<App />);
reportWebVitals();
